import React, { useState,useEffect } from 'react'
import { IssuesWrapper } from './Issues.style'
import { FilterData, getDate } from 'helper/utils';
import { Tabs,message ,Table,Modal} from 'antd';
import SearchBar from 'components/comman/SearchBar/SearchBar';
import NoDataFound from 'components/comman/NoDataFoundComponent/NoDataFound';
import SecuredServices from 'api/securedServices';
import ContentCard from 'components/comman/contentCard/ContentCard';
import IssuesCard from 'components/comman/issuesCard/IssuesCard';
import { useNavigate } from 'react-router-dom';
import { RouteDefinitions } from 'api/routes/routeDefinitions';
import {ExclamationCircleFilled} from '@ant-design/icons';


const { confirm } = Modal;



const columns = [
    {
        title:"qName",
        sorter: (a, b) => a.q_name - b.q_name,
        render: (text, record) => {
            return (
              <span>{record.q_name} {record.auto_generated && parseInt(record.auto_generated)!=0?`(${record.auto_generated})`:""}</span>
            )}

    },
    {
        title:"Grade",
        dataIndex:"grade_id",
        sorter: (a, b) => a.grade_id - b.grade_id,
    },
    {
        title:"Topic",
        dataIndex:"topic_name",
        sorter: (a, b) => a.topic_name - b.topic_name,
    },
    {
        title:"Q Type",
        dataIndex:"content_type"

    },
    {
        title: "Is Paid",
        dataSource:"paid",
        render: (text, record) => {
            return <>{
                text.paid==1 ?"Paid":"Not Paid"
            }</>
        },
        sorter: (a, b) =>  a.paid-b.paid,
  
    },
    {
        title:"Status",
        dataIndex:"status",
        sorter: (a, b) => {
            return  a.status.localeCompare(b.status)
          },    },
     {
       title: "Date",
       render: (text, record, index) => {
         return <p>{getDate(record.createdAt)}</p>;
       },
       sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
     },
   
]
export default function Issues() {
    const [activeKey,setActiveKey] = useState("2");
    const [issuesList,setIssuesList] = useState([]);
    const [baseIssuesList,setBaseIssuesList] = useState([]);
    const [userIssuesList,setUserIssuesList] = useState([]);
   
    const [baseUserIssuesList,setBaseUserIssuesList] = useState([]);

    const [cmsAdminToken,setCmsAdminToken] = useState("");
    const [feedBackDetailsModal,setFeedBackDetailsModal] = useState(false);
    const [searchQuery,setSearchQuery] = useState("");
    const [dataSource,setDataSource] = useState([]);
    const [selectedCard,setSelectedCard] = useState({});
    const [questionDetailsModal,setQuestionDetailsModal] = useState(false);

    const navigate = useNavigate();

    const onCardClick  = (item)=>{
      navigate(RouteDefinitions.ROUTE_ISSUES_FIXING_SCREEN,{state:item});
    }


    useEffect(()=>{
        console.log(selectedCard);
        if(activeKey=="1"){
            getALLquestions();
        } 
        else if(activeKey=="2"){
            getUserquestions();
        }
        else if(activeKey=="3"){

            // SecuredServices.getProgramerSubmittedQuestion().then((res)=>{
            //     console.log(res.data);
            //     if(res.data.status==1){
            //         console.log(res.data.data);
            //         let submittedData =res.data.data;
            //         if(submittedData.length>0){
            //             submittedData.forEach((data)=>{
            //                 const blob1 = new Blob([data.q_tex], { type: 'text/plain' });
            //                 const blob2 = new Blob([data.a_tex], { type: 'text/plain' });
            //                 const blob3 = new Blob([data.iq_annotation], { type: 'text/plain' });
            //                 const  url1 = URL.createObjectURL(blob1);
            //                 const  url2 = URL.createObjectURL(blob2);
            //                 const  url3 = URL.createObjectURL(blob3);
            //                 data.q_tex_link = url1;
            //                 data.a_tex_link = url2;
            //                 data.iq_annotation_link = url3;
            //                 console.log(data);
            //             })
            //         }
            //         setDataSource(submittedData);
            //     }
            // })
        }
        
    },[activeKey])


    const getALLquestions = ()=>{
        SecuredServices.getAllPendingIssues().then((res)=>{
            console.log(res.data);
            if(res.data.status==1){
                console.log(res.data.data);
                setIssuesList(res.data.data?res.data.data:[]);
                setBaseIssuesList(res.data.data);
            }
        }).catch((err)=>{
            console.log(err);
        })
    }


    const getUserquestions = ()=>{
        SecuredServices.getAllUserPendingIssues().then((res)=>{
            console.log(res.data);
            if(res.data.status==1){
                console.log(res.data.data);
                setCmsAdminToken(res.data.data[0]?.token);
                setUserIssuesList(res.data.data);
                setBaseUserIssuesList(res.data.data);
            }
        }).catch((err)=>{
            console.log(err);
        })
    }


    const OnClickOnFeedback = (item)=>{
        console.log(item);
        item.token = cmsAdminToken;
        setSelectedCard(item);
        setFeedBackDetailsModal(true);
    }

    const assignIssueToUser = (live_q_name)=>{
      
            let data = {
                live_q_name :live_q_name,
            }

            SecuredServices.assignIssueToUser(data).then((res)=>{
                console.log(res.data);
                if(res.data.status==1){
                    message.success(res.data.message);
    
                    let tempBaseIssuesList = [...baseIssuesList.filter((item)=>item.live_q_name!=live_q_name)];
                    let tempIssuesList = [...issuesList.filter((item)=>item.live_q_name!=live_q_name)];
                    setBaseIssuesList(tempBaseIssuesList);
                    setIssuesList(tempIssuesList);
                }
                else{
                    message.error(res.data.message);
                }
            }).catch((err)=>{
                console.log(err);
                message.error("Something went wrong, please try again");
            })
    }

    const handleSearchBarChange = (filteredData)=>{
        setIssuesList(filteredData);
    }


    const deAssignIssueToUser =(live_q_name)=>{

        confirm({
            title: 'Are you sure?',
            icon: <ExclamationCircleFilled />,
            content: 'All questions with this q_name will be removed from your Assigned Tab.',
            okText: 'Yes',
            okType: 'warning',
            cancelText: 'No',
            onOk() {
                let data = {
                    live_q_name :live_q_name,
                }
                SecuredServices.deAssignIssueToUser(data).then((res)=>{
                    console.log(res.data);
                    if(res.data.status==1){
                        message.success(res.data.message);
                        setBaseUserIssuesList(baseUserIssuesList.filter((item)=>item.live_q_name!=live_q_name));
                        setUserIssuesList(userIssuesList.filter((item)=>item.live_q_name!=live_q_name));
                    }
                    else{
                        message.error(res.data.message);
                    }
                }).catch((err)=>{
                    console.log(err);
                    message.error("Something went wrong, please try again");
                })
               
            }
             
        })
      
          
    }


    const handleSearchBarChangeForUser = (filteredData)=>{
        setUserIssuesList(filteredData);
    }

  return (
    <IssuesWrapper>
        <div>
        <h3>Pending Issues</h3>
        <div >
            <Tabs defaultActiveKey="2" 
            onChange={(key)=>{
                setSearchQuery("");
                setActiveKey(key)}}
             >
                <Tabs.TabPane tab="Pending" key="1">
                <div className='issuesListParent'>
                  <SearchBar data={baseIssuesList} setFilteredData={handleSearchBarChange} />
                {issuesList.length==0?<NoDataFound/>:
                  <div className='issuesList'>
                  {  
                      issuesList.map((item,index)=>{
                        return <IssuesCard key={index} item={item} buttonType={1} handleButtonClick={assignIssueToUser} tag1={item.type} />
                      })
                  }
              
              </div>
                }
              
            </div>
                </Tabs.TabPane>
                <Tabs.TabPane tab="Assigned" key="2">
                    <div className='issuesListParent'>
                    <SearchBar data={baseUserIssuesList} setFilteredData={handleSearchBarChangeForUser} />
                        { 
                        userIssuesList.length==0?<NoDataFound/>:
                        <div className='issuesList'>
                        {
                            userIssuesList.map((item,index)=>{
                                console.log(item);
                                return <div key={index}>
                                    <IssuesCard item={item} buttonType={2}  onClickOnCard={()=>onCardClick(item)} handleButtonClick={deAssignIssueToUser} tag1={item.type} />
                                    </div>
                            })
                        }
                     
                    </div>
                        }
                   
                    </div>
               
                </Tabs.TabPane>
                <Tabs.TabPane tab="Submitted" key="3">
                     <div>
                     <Table dataSource={dataSource} columns={columns} />
                     </div>
                </Tabs.TabPane>
                </Tabs>
        </div>
          
        </div>

    </IssuesWrapper>
  )
}
